module.exports = __webpack_public_path__ + "static/img/ing-life.d1bb47b.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project/ing-life.jpg
// module id = 84Ax
// module chunks = 0